<template>
  <div
    class="comment-info"
    :class="isH5 ? 'h5-comment-info' : 'pc-comment-info'"
  >
    <Header v-if="!isHXApp" title="评价详情" />

    <div class="page-cont">
      <div class="top-cont">
        <div class="course-info">
          <img
            class="cover"
            :src="info.cover_url + '?imageView2/0/w/300'"
            alt=""
          />
          <p class="title">
            {{ info.course_name }}
          </p>
        </div>
        <div class="score-list">
          <p class="total-score">
            <span class="title">整体评价</span>
            <Star :score="info.star" />
          </p>

          <ul class="subScore">
            <li v-for="item in subScore" :key="item.name" class="score-item">
              <span class="title">{{ item.title }}</span>
              <span v-if="info[item.name]" class="value">
                {{ info[item.name].toFixed(1) }}</span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom-cont">
        <ul v-if="info.tag && info.tag.length" class="tag-list">
          <li v-for="(item, index) in info.tag" :key="item + index">
            {{ tagName(item) }}
          </li>
        </ul>
        <div v-if="info.comment" class="comment">{{ info.comment }}</div>
        <div
          v-if="info.comment_img && info.comment_img.length"
          class="image-list"
        >
          <img
            @click="handlePreview(index)"
            class="img-item"
            v-for="(item, index) in info.comment_img"
            :key="item + index"
            :src="item"
            alt=""
          />
          <el-image
            style="display: none"
            ref="elImage"
            :initial-index="initialIndex"
            src=""
            :preview-src-list="info.comment_img"
          ></el-image>
        </div>
        <p v-if="noContent" class="no-content">无评价内容</p>
        <p class="time-wrap">
          <span class="time">{{
            moment(info.last_update_time * 1000).format("YYYY.MM.DD HH:mm")
          }}</span>
          <span>学习 {{ info.lesson_count }} 课时评价</span>
        </p>
      </div>
      <div class="operate-wrap">
        <div class="left">
          <p v-if="info.anonymity === 1" class="anonymity">
            <img src="../../assets/images/comment/anonymity.png" alt="" />
            匿名
          </p>
        </div>
        <!-- 提交评论的 30 天内可以编辑或删除评论 -->
        <p v-if="canOperate" class="right">
          <span v-if="info.edit === 1" class="edit-wrap">
            <button @click="jumpEditPage" class="edit">编辑</button>
            <span class="separation"></span>
          </span>
          <button @click="handleDel" class="del">删除</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { TAGLIST } from "@saas/components/src/constants/comment";
import { getCommentInfo, delComment } from "@saas/service-api/src/comment";
import { Header, isHXApp, isH5, Star } from "@saas/components";
export default {
  data: function () {
    return {
      moment,
      id: "",
      info: {},
      tagList: TAGLIST,
      isHXApp: isHXApp(),
      isH5: isH5(),
      initialIndex: 0,
      anonymity: true,
      subScore: [
        {
          name: "content_star",
          title: "课程内容",
        },
        {
          name: "aura_star",
          title: "课堂氛围",
        },
        {
          name: "teacher_star",
          title: "老师风采",
        },
      ],
    };
  },
  created() {
    this.comment_id = this.$route.params.comment_id;
    this.apiGetCommentInfo();
  },
  methods: {
    handleDel() {
      this.$confirm(
        "每个课程只能提交一次评价。删除评价后，您将无法再次对此课程进行评价，是否确认删除？",
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确认",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          closeOnClickModal: false,
        }
      )
        .then(() => {
          this.apiDelComment();
        })
        .catch(() => {});
    },
    apiDelComment() {
      let params = {
        id: this.comment_id,
      };
      delComment(params).then((res) => {
        if (res.code === 1) {
          this.$message.success("删除完成");
          this.$router.back();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    jumpEditPage() {
      this.$router.push({
        name: "EditComment",
        params: {
          comment_id: this.comment_id,
        },
      });
    },
    apiGetCommentInfo() {
      let params = {
        id: this.comment_id,
      };
      getCommentInfo(params).then((res) => {
        if (res.code === 1) {
          let data = res.data || {};
          if (data?.comment_img?.length) {
            data.comment_img = data.comment_img.map((item) => {
              if (item.startsWith("https") || item.startsWith("http")) {
                return item;
              } else {
                return `https:${item}`;
              }
            });
          }
          this.info = res.data || {};
        } else if (res.code === 1111) {
          this.$chiralAutoMessage(`该评价已删除或不存在`, 1200);
          setTimeout(() => {
            this.$router.push({
              name: "CommentList",
            });
          }, 1200);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handlePreview(index) {
      this.initialIndex = index;
      this.$refs.elImage.clickHandler();
    },
  },
  computed: {
    noContent() {
      return (
        !this.info?.tag?.length &&
        !this.info?.comment &&
        !this.info?.comment_img?.length
      );
    },
    tagName() {
      return (id) => {
        return this.tagList.filter((item) => {
          return item.id === id;
        })[0]?.name;
      };
    },
    canOperate() {
      if (this.info) {
        let { last_update_time } = this.info;
        let now = new Date().getTime();
        if (now < last_update_time * 1000 + 30 * 24 * 60 * 60 * 1000) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  components: {
    Header,
    Star,
  },
};
</script>

<style lang="scss" scoped>
.pc-comment-info {
  background-color: #f7f8f9;
  min-height: 100vh;

  .page-cont {
    max-width: 800px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .top-cont {
    padding: 12px;
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    margin-bottom: 10px;
    .course-info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .cover {
        width: 140px;
        height: 78px;
        margin-right: 12px;
        border-radius: 14px;
        object-fit: cover;
      }
      .title {
        flex: 1;
        width: 0;
        font-weight: 500;
        font-size: 18px;
        color: #0d1400;
        line-height: 25px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }
    .total-score {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #0d1400;
        line-height: 22px;
        margin-right: 8px;
      }
    }
    .subScore {
      display: flex;
      align-items: center;
    }
    .score-item {
      margin-right: 40px;
      display: flex;
      align-items: center;
      .title {
        font-weight: 400;
        font-size: 16px;
        color: #0d1400;
        line-height: 25px;
        margin-right: 12px;
      }
      .value {
        font-weight: 500;
        font-size: 18px;
        color: #0d1400;
        line-height: 25px;
      }
    }
    .score-item:last-child {
      margin-right: 0;
    }
  }

  .bottom-cont {
    padding: 24px 16px 20px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    .tag-list {
      display: flex;
      align-items: center;
      li {
        width: 87px;
        height: 30px;
        background: rgba(0, 200, 157, 0.08);
        border-radius: 15px;
        font-weight: 400;
        font-size: 16px;
        color: #00c89d;
        line-height: 30px;
        margin-right: 10px;
        margin-bottom: 14px;
        text-align: center;
      }
      li:last-child {
        margin-right: 0;
      }
    }
    .comment {
      white-space: pre-wrap;
      padding-left: 2px;
      font-weight: 400;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      margin-bottom: 16px;
      word-break: break-all;
    }
    .img-item {
      width: 90px;
      height: 90px;
      border-radius: 14px;
      border: 1px solid #efefef;
      display: inline-block;
      margin-right: 16px;
      margin-bottom: 16px;
      object-fit: cover;
      cursor: pointer;
    }
    .img-item:last-child {
      margin-right: 0;
    }
    .no-content {
      font-weight: 400;
      font-size: 18px;
      color: #515350;
      line-height: 25px;
      margin-bottom: 12px;
    }
    .time-wrap {
      padding-left: 2px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 22px;
      .time {
        margin-right: 30px;
      }
    }
  }

  .operate-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 18px 0 0;
    img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
    .anonymity {
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 22px;
    }
    .edit {
      font-weight: 400;
      font-size: 16px;
      color: #00c89d;
      line-height: 22px;
    }
    .del {
      font-weight: 400;
      font-size: 16px;
      color: #f03349;
      line-height: 22px;
    }
    .separation {
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #e1e1e1;
      border-radius: 1px;
      margin: 0 16px;
    }
    .anonymity,
    .right,
    .edit-wrap {
      display: flex;
      align-items: center;
    }
  }
}

.h5-comment-info {
  background-color: #f7f8f9;
  min-height: 100vh;
  .page-cont {
    padding: 0.13rem 0.32rem 0;
  }

  .top-cont {
    .course-info {
      height: 2.19rem;
      padding: 0 0.32rem;
      background: #ffffff;
      border-radius: 0.32rem;
      margin-bottom: 0.27rem;
      display: flex;
      align-items: center;

      .cover {
        width: 2.81rem;
        height: 1.58rem;
        border-radius: 0.13rem;
        margin-right: 0.15rem;
        object-fit: cover;
      }
      .title {
        flex: 1;
        width: 0;
        font-weight: 600;
        font-size: 0.37rem;
        color: #0d1400;
        line-height: 0.53rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .score-list {
      background: #ffffff;
      border-radius: 0.32rem 0.32rem 0 0;
      border-bottom: 0.01rem solid #efefef;
      padding: 0.27rem 0.32rem 0.32rem;
    }
    .total-score {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      .title {
        font-weight: 600;
        font-size: 0.4rem;
        color: #0d1400;
        line-height: 0.56rem;
        margin-right: 0.25rem;
      }
    }
    .subScore {
      display: flex;
      align-items: center;
    }
    .score-item {
      margin-right: 0.48rem;
      display: flex;
      align-items: center;
      .title {
        font-weight: 400;
        font-size: 0.4rem;
        color: #0d1400;
        line-height: 0.56rem;
        margin-right: 0.19rem;
      }
      .value {
        font-weight: 500;
        font-size: 0.41rem;
        color: #0d1400;
        line-height: 0.59rem;
      }
    }
    .score-item:last-child {
      margin-right: 0;
    }
  }

  .bottom-cont {
    padding: 0.32rem;
    background: #ffffff;
    border-radius: 0px 0px 0.32rem 0.32rem;
    .tag-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li {
        width: 2.03rem;
        height: 0.72rem;
        background: rgba(0, 200, 157, 0.08);
        border-radius: 0.35rem;
        font-weight: 400;
        font-size: 0.37rem;
        color: #00c89d;
        line-height: 0.72rem;
        margin-right: 0.2rem;
        margin-bottom: 0.21rem;
        text-align: center;
      }
      li:nth-child(4n) {
        margin-right: 0;
      }
    }
    .comment {
      white-space: pre-wrap;
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      margin-bottom: 0.32rem;
      word-break: break-all;
    }
    .image-list {
      padding-bottom: 0.08rem;
    }
    .img-item {
      width: 2rem;
      height: 2rem;
      border-radius: 0.32rem;
      border: 0.01rem solid #efefef;
      display: inline-block;
      margin-right: 0.24rem;
      margin-bottom: 0.24rem;
      object-fit: cover;
      cursor: pointer;
    }
    .img-item:nth-child(4n) {
      margin-right: 0;
    }
    .no-content {
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
      margin-bottom: 0.27rem;
    }
    .time-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
    }
  }

  .operate-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.27rem 0.13rem 0;
    img {
      width: 0.43rem;
      height: 0.43rem;
      margin-right: 0.16rem;
    }
    .anonymity {
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
    }
    .edit {
      font-weight: 400;
      font-size: 0.37rem;
      color: #00c89d;
      line-height: 0.53rem;
    }
    .del {
      font-weight: 400;
      font-size: 0.37rem;
      color: #f03349;
      line-height: 0.53rem;
    }
    .separation {
      display: inline-block;
      width: 0.03rem;
      height: 0.24rem;
      background: #e1e1e1;
      border-radius: 0.03rem;
      margin: 0 0.27rem;
    }
    .anonymity,
    .right,
    .edit-wrap {
      display: flex;
      align-items: center;
    }
  }
}
</style>
